/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { API_PATH } from "src/environments/config";

@Injectable({
  providedIn: "root",
})
export class RegisterStoreApiService {
  constructor(public http: HttpClient) {}
  postRegisterPreSignUpOtp(data) {
    return this.http.post<any>(API_PATH.apis.signup, data);
  }
  storeLogin(data, isSrsm?, isPatrician?) {
    if (isSrsm) {
      data["localCode"] = "SRSM";
    } else if (isPatrician) {
      data["localCode"] = "PATRICIANASH";
    }
    if (isPatrician) {
      data["localCode"] = "PATRICIANASH";
    }
    data["domainUrlCheck"] = true;
    return this.http.post<any>(API_PATH.apis.signin, data);
  }
  postLeadForm(data) {
    return this.http.post<any>(API_PATH.apis.registerStore, data);
  }
}
